import React, { useState } from 'react';
import { ThemeProvider } from '@material-ui/core/styles';
import {
  Avatar, Button, CssBaseline, TextField, Link, Grid,
  Typography, Container, AppBar, Toolbar, IconButton
} from '@material-ui/core'
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import SettingsIcon from '@material-ui/icons/Settings'
import { makeStyles } from '@material-ui/core/styles';
import history from '../../services/history.service'
import { DARK_THEME } from '../../common/theme'

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(30),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  form: {
    width: '100%',
    marginTop: theme.spacing(3),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  }
}));

function SignUp() {
  const classes = useStyles();

  const [firstname, setFirstname] = useState('');
  const [lastname, setLastname] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassowrd] = useState('');
  const [confirmPassword, setConfirmPassowrd] = useState('');
  const [firstnameError, setFirstnameError] = useState('');
  const [lastnameError, setLastnameError] = useState('');
  const [emailError, setEmailError] = useState('');
  const [passwordError, setPasswordError] = useState('');

  function onSubmit() {
    const emailRegexp = /[A-Z0-9._%+-]+@[A-Z0-9.-]+.[A-Z]{2,4}$/i;
    if (firstname === '' || firstname === null || firstname === undefined) {
      setFirstnameError('Firstname required');
    }
    else {
      setFirstnameError('')
    }
    if (lastname === '' || lastname === null || lastname === undefined) {
      setLastnameError('Lasname required');
    }
    else {
      setLastnameError('')
    }
    if (email === '' || email === null || email === undefined) {
      setEmailError('Email required');
    }
    else if (!emailRegexp.test(email)) {
      setEmailError('Invalid email address');
    }
    else {
      setEmailError('')
    }
    if (password === '' || password === null || password === undefined) {
      setPasswordError('Password required');
    }
    else if (password !== confirmPassword) {
      setPasswordError('Both the passwords don\'t match')
    }
    else {
      setPasswordError('')
    }
  }

  return (
    <ThemeProvider theme={DARK_THEME}>
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <AppBar position="fixed">
          <Toolbar>
            <IconButton edge="start" aria-label="menu">
              <SettingsIcon fontSize="large" />
            </IconButton>
            <Typography variant="h6" noWrap>
              Service Request Portal
          </Typography>
          </Toolbar>
        </AppBar>
        <div className={classes.paper}>
          <Avatar>
            <LockOutlinedIcon />
          </Avatar>
          <Typography style={{
            "color": DARK_THEME.palette.primary.contrastText
          }} component="h1" variant="h5">
            Sign up
        </Typography>
          <form className={classes.form} noValidate>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <TextField
                  autoComplete="fname"
                  name="firstName"
                  variant="outlined"
                  required
                  fullWidth
                  id="firstName"
                  placeholder="First Name"
                  value={firstname}
                  onChange={(e) => { setFirstname(e.target.value) }}
                  error={firstnameError === '' ? false : true}
                  helperText={firstnameError}
                  autoFocus
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  variant="outlined"
                  required
                  fullWidth
                  id="lastName"
                  placeholder="Last Name"
                  name="lastName"
                  autoComplete="lname"
                  value={lastname}
                  onChange={(e) => { setLastname(e.target.value) }}
                  error={lastnameError === '' ? false : true}
                  helperText={lastnameError}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  variant="outlined"
                  required
                  fullWidth
                  id="email"
                  placeholder="Email Address"
                  name="email"
                  autoComplete="email"
                  value={email}
                  onChange={(e) => { setEmail(e.target.value) }}
                  error={emailError === '' ? false : true}
                  helperText={emailError}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  variant="outlined"
                  required
                  fullWidth
                  name="password"
                  placeholder="Password"
                  type="password"
                  id="password"
                  autoComplete="current-password"
                  value={password}
                  onChange={(e) => { setPassowrd(e.target.value) }}
                  error={passwordError === '' ? false : true}
                  helperText={passwordError}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  variant="outlined"
                  required
                  fullWidth
                  name="confirm password"
                  placeholder="Confirm Password"
                  type="password"
                  id="password"
                  autoComplete="current-password"
                  value={confirmPassword}
                  onChange={(e) => { setConfirmPassowrd(e.target.value) }}
                  error={passwordError === '' ? false : true}
                  helperText={passwordError}
                />
              </Grid>
            </Grid>
            <Button
              fullWidth
              variant="contained"
              color="secondary"
              onClick={() => { onSubmit() }}
              className={classes.submit}
            >
              Sign Up
          </Button>
            <Grid container justify="flex-end">
              <Grid item>
                <Link
                  onClick={() => {
                    history.push('/login')
                  }}
                  variant="body2">
                  Already have an account? Sign in
              </Link>
              </Grid>
            </Grid>
          </form>
        </div>
      </Container>
    </ThemeProvider>
  );
}

export default SignUp;